<template>
    <!-- Affiché quand l'onglet sert des données du cache 5 min (service/cacheTableauDeBord.js). -->
    <div class="cf-note cf-note--info tb-cache" role="status">
        <i class="ri-information-line"></i>
        <span>
            Pour aller plus vite, {{ quoi }} {{ verbe }} 5 minutes sur ce poste<template v-if="heure"> (données de {{ heure }})</template>.
            {{ manque }}
            Cliquez sur <a href="javascript:void(0)" class="tb-cache__lien" @click="$emit('actualiser')">Actualiser</a> pour voir les derniers chiffres.
        </span>
    </div>
</template>

<script>
    export default {
        /* eslint-disable */
        name: "bandeaucachetb",
        emits: ['actualiser'],
        props: {
            /* ce qui est gardé, ex. « les chiffres de caisse » */
            quoi: { type: String, required: true },
            /* accordé avec quoi : « sont gardés », « est gardée »... */
            verbe: { type: String, default: 'sont gardés' },
            /* ce qui manque tant qu'on n'actualise pas */
            manque: { type: String, default: '' },
            heure: { type: String, default: '' },
        },
    }
</script>

<style scoped>
    .tb-cache { margin-bottom: 0.75rem; }
    .tb-cache__lien { font-weight: 600; text-decoration: underline; color: #1d4ed8; }
</style>
